import { Injectable } from '@angular/core';
import { AbstractDealConfigService } from 'bqx-deal';
import { LogLevel, LoggerAbstractService } from 'bqx-logging';
import { AppConfig } from 'src/app/app.config';
import { AbstractAuthService } from '../auth/auth.abstract.service';

@Injectable({ providedIn: 'root' })
export class DealIntegrationConfigService implements AbstractDealConfigService {
  constructor(private logger: LoggerAbstractService, private authService: AbstractAuthService) {}
  log(error: Error): void {
    this.logger.postLogData(LogLevel.Error, error.message);
  }

  get apiToken(): string {
    return this.authService.accessToken;
  }

  get dealUrl(): string {
    return AppConfig.settings.dealAnalytics.baseUrl;
  }

  get domain(): string {
    const myDomain = 'Commercial Quoting';
    return myDomain;
  }

  get application(): string {
    const myAgent = 'BQX';
    return myAgent;
  }

  get slssid(): string {
    const mySlssid = document.cookie
      .split('; ')
      .find((row) => row.startsWith('SLAVESS='))
      ?.split('=')[2];
    const id = mySlssid ? mySlssid : crypto.randomUUID().toString().replaceAll('-', '');
    return id;
  }
}
